module.exports = __webpack_public_path__ + "fed6a50e1f679c6dc7c0a093591aaa6c.pdf";